import { render, staticRenderFns } from "./noVoiceDetected.vue?vue&type=template&id=110dcffe&"
import script from "./noVoiceDetected.vue?vue&type=script&lang=js&"
export * from "./noVoiceDetected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports